import { CheckoutAddress } from './checkout-address.interface';
import { CheckoutEmail } from './checkout-email.interface';
import { CheckoutPhone } from './checkout-phone.interface';

export interface CheckoutPerson {
  address: CheckoutAddress[];
  email: CheckoutEmail[];
  firstName: string;
  phone: CheckoutPhone[];
  surname: string;
}
